Vendd.Scripts.load(function () {
    var $wrapper = $('.x-searchbox.elastic');

    if ($wrapper.length < 1)
        return;

    $.each($wrapper, function (i, wrapper) {
        var $wrapper = $(wrapper);

        var $input = $('.js-keyword', $wrapper);
        $input.val("");
        var $button = $('.js-submit', $wrapper);
        var $toggleButton = $('.js-search-toggle', $wrapper);
        var $closeButton = $('.js-search-close', $wrapper);
        var minLength = $wrapper.data('min-search-length');
        var pdPageSize = $wrapper.data('pd-page-size');
        var catPageSize = $wrapper.data('cat-page-size');
        var artPageSize = $wrapper.data('art-page-size');
        var filtered = $wrapper.data('product-categories-filter');
        var showOnlyProducts = $wrapper.data('only-products');
        var mask = $wrapper.data('mask');      
        var lazyLoadPrices = $wrapper.data('lazyload-prices');
        if (typeof lazyLoadPrices === 'string') {
            lazyLoadPrices = lazyLoadPrices.trim().toLowerCase() === 'true';
        }

        var ajax = $wrapper.data('ajax');
        if (typeof ajax === 'string')
            ajax = ajax.trim().toLowerCase() === 'true';
        var lazy = false;

        var $category, $elastic;
        var model = {};

        var searchTerm = ""; pdPageNum = 1, pdPageStart = 0, pdFirstShown = 0, pdLastShown = 0, catPageNum = 1, catFirstShown = 0, catLastShown = 0,
            catPageStart = 0, artPageNum = 1, artPageStart = 0, artFirstShown = 0, artLastShown = 0, scrollToPd = false, scrollToCat = false, scrollToArt = false;

        if (ajax) {
            $elastic = $(".x-elastic-results-list", $wrapper);

            if ($elastic.length <= 0)
                throw 'Error: Elastic List does not exist';

            lazy = $elastic.data("lazy-load-init");

            Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetCategoryElasticResultsFailed, wrapper, function (envelope) {
                model.categories = null;
                wrapper.loading(false);
            });

            Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetProductElasticResultsFailed, wrapper, function (envelope) {
                model.products = null;
                wrapper.loading(false);
            });

            Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetArticleElasticResultsFailed, wrapper, function (envelope) {
                model.article = null;
                wrapper.loading(false);
            });

            Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetCategoryElasticResultsSuccess, wrapper, function (envelope) {
                model.categories = envelope.message.data.model;
                wrapper.render();
            });

            Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetProductElasticResultsSuccess, wrapper, function (envelope) {
                if (envelope.message.data.sender != wrapper) return;

                model.products = envelope.message.data.model;
                wrapper.render();
            });

            Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetArticleElasticResultsSuccess, wrapper, function (envelope) {
                model.articles = envelope.message.data.model;
                wrapper.render();
            });
        }

        wrapper.render = function () {
            if (!model.categories) return;
            if (!model.products) return;
            if (!model.articles) return;

            model.products.literals.PriceNakasText = $('.header-region.header-template-one').data('price-nakas-text') || 'Τιμή Nakas';
            model.products.literals.PriceWebText = $('.header-region.header-template-one').data('price-web-text') || 'Τιμή Web';
            model.products.literals.PricePubText = $('.header-region.header-template-one').data('price-pub-text') || 'Τιμή Εκδότη';

            if (model.products && model.products.hits.hits.length > 0) {
                model.products.hits.hits.forEach(function (product) {
                    //create an object with default sku dimension - used for product image
                    var defaultSkuDimension = product._source.Dimensions.find(function (x) { return product._source.VariantId === x.SkuId; });
                    if (defaultSkuDimension) product._source.DefaultSkuDimension = defaultSkuDimension;

                    //Create IsGiftCard property
                    product._source.IsGiftCard = (product._source.ProductType.Code && product._source.ProductType.Code === 'gift-cart');
                });
            }

            //check if current user has custom prices
            var currentUser = Vendd.User && Vendd.User.GetClientModel();
            var customPrices = currentUser && currentUser.HasCustomPrices;
            model.LazyLoadPrices = lazyLoadPrices || customPrices;

            if (model.LazyLoadPrices && model.products && model.products.hits.hits.length > 0) {
                var items = model.products.hits.hits.map(function (x) { return x._source }).map(function (y) { return y.VariantId });
                var obj = {
                    itemIds: items,
                    fetchPrices: true,
                    fetchAvailabilities: false,
                    fetchStock: false
                };
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.ScrollList.Messages.GetClientProductListData(obj));

                Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetClientProductListDataSuccess, wrapper, function (envelope) {
                    var raw = envelope && envelope.message && envelope.message.data;
                    if (raw === undefined || raw === null || raw === '') return;

                    var result = JSON && JSON.parse(envelope.message.data) || $.parseJSON(envelope.message.data);
                    var b2bModel = result.B2B;
                    var shouldHidePrices = b2bModel && b2bModel.DisplayOptions && b2bModel.DisplayOptions.ShouldHidePrice;

                    //extend model
                    model.B2BModel = { ...{}, ...b2bModel };
                    model.ShowPriceWithoutVat = result.ShowPriceWithoutVat;

                    if (!shouldHidePrices) {
                        var modelWithPrices = model.products.hits.hits.forEach(function (obj) {
                            var selectedProduct = result.Products.find(function (x) { return obj._source.VariantId === x.VariantId; });
                            if (selectedProduct) obj._source = { ...obj._source, ...selectedProduct.Prices };
                        });
                        model.products.hits.hits = { ...model.products.hits.hits, ...modelWithPrices };
                    }

                    wrapper.bind();

                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.GetModel());

                    setTimeout(function () { $elastic.removeClass('loading'); }, 50);

                    Vendd.MessageBus.unsubscribe(Vendd.ScrollList.Messages.GetClientProductListDataSuccess, wrapper);

                    /* Track Search & SearchTerm */
                    if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                        if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                            fbq('track', 'Search');
                            fbq('trackCustom', 'SearchTerm', { search_string: searchTerm });
                        }
                    }
                    /* END Track Search & SearchTerm */
                });

            } else {

                wrapper.bind();

                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.GetModel());

                if (model.categories.hits.hits.length < 1 && model.products.hits.hits.length < 1 && model.articles.hits.hits.length < 1)
                    $('.no-results.results', $elastic).addClass('visible');

                setTimeout(function () { $elastic.removeClass('loading'); }, 50);

                /* Track Search & SearchTerm */
                if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                    if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                        fbq('track', 'Search');
                        fbq('trackCustom', 'SearchTerm', { search_string: searchTerm });
                    }
                }
                /* END Track Search & SearchTerm */
            }
        };

        wrapper.bind = function () {
            model.AddToCartMob = $wrapper.data('add-to-cart-text');
           
            model.products.hits.hits.forEach(function (product) {
                product._source.hasPersonalizedMessage = product._source.Attributes.some(function (attr) {
                    return attr.Code === 'ItemAttributes_ShowPersonalizedMessage' && attr.Value === true;
                });
            });
            
            var html = Vendd.Handlebars.parse("elasticResultList_A", model);
            $elastic.html(html);

            Vendd.MessageBus.publishAsync($elastic.get(0), new Vendd.Widget.Messages.BindControl($elastic));

            wrapper.pdPaging();
            wrapper.catPaging();
            wrapper.artPaging();

            wrapper.showList(true);
            wrapper.loading(false);
        };

        wrapper.loading = function (loading) {
            if (loading) {
                $wrapper.addClass('x-loading').addClass('x-disabled');
            } else {
                $wrapper.removeClass('x-loading').removeClass('x-disabled');
            }
        };

        wrapper.clearValue = function () {
            $input.val("");
        };

        wrapper.checkSearchTerm = function () {
            return /[a-zα-ωάέήίόύώϊϋΐΰςа-я0-9]+/i.test(searchTerm);
        };

        wrapper.showList = function (show) {
            if (ajax && $elastic.length > 0) {
                if (show) {
                    $('html').addClass('no-scroll');
                    if ($('.header-region').hasClass('sticky')) {
                        $('.header-spacer').height(0);
                        $('.header-region').removeClass('sticky');
                    }
                    $elastic.addClass('js-visible');
                    $wrapper.addClass('overlaid');
                    $('.header-region').addClass('active clean-zindex');
                    $('.header-overlay').addClass('active');
                    setTimeout(function () { calculateSearchHeight(); }, 150);
                } else {
                    $('html').removeClass('no-scroll');
                    $('.header-region').removeClass('active clean-zindex');
                    $('.header-overlay').removeClass('active');
                    $wrapper.removeClass('overlaid');
                    $elastic.removeClass('js-visible');
                }
            }
        };

        wrapper.pdPaging = function () {
            var pdCont = $('.elastic-area.products', $elastic);
            var pdTotal = pdCont.data('total');

            if (scrollToPd) {
                $(".result-list-wrapper", $elastic).animate({ scrollTop: pdCont.offset().top - $(".result-list-wrapper", $elastic).offset().top }, 1);
            }

            if (pdTotal > pdPageSize) {
                $('.prev-btn', pdCont).removeClass('hidden');
                $('.next-btn', pdCont).removeClass('hidden');
            }

            if (pdPageStart <= 0) {
                $('.prev-btn', pdCont).addClass('disabled');
            }

            if ((pdPageStart + pdPageSize) >= pdTotal) {
                $('.next-btn', pdCont).addClass('disabled');
                if (pdTotal > pdPageSize) {
                    pdFirstShown = pdPageStart + 1;
                    pdLastShown = pdTotal;
                    $('.js-pd-info', pdCont).append(", <span class='shown'>" + pdCont.data('fromtext') + " " + pdFirstShown + " " + pdCont.data('totext') + " " + pdLastShown + "</span>");
                }
            }

            if (((pdPageStart + pdPageSize) < pdTotal) && (pdTotal > pdPageSize)) {
                pdFirstShown = pdPageStart + 1;
                pdLastShown = pdPageStart + pdPageSize;
                $('.js-pd-info', pdCont).append(", <span class='shown'>" + pdCont.data('fromtext') + " " + pdFirstShown + " " + pdCont.data('totext') + " " + pdLastShown + "</span>");
            }

            $('.prev-btn', pdCont).click(function () {
                if (!$(this).hasClass('disabled')) {
                    $elastic.addClass('loading');
                    pdPageStart -= pdPageSize;
                    pdPageNum--;
                    scrollToPd = true;
                    scrollToCat = false;
                    scrollToArt = false;
                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.ElasticSearch.Messages.GetProductElasticResults(searchTerm, pdPageNum, pdPageSize));
                } else {
                    scrollToPd = false;
                }
            });

            $('.next-btn', pdCont).click(function () {
                if (!$(this).hasClass('disabled')) {
                    $elastic.addClass('loading');
                    pdPageStart += pdPageSize;
                    pdPageNum++;
                    scrollToPd = true;
                    scrollToCat = false;
                    scrollToArt = false;
                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.ElasticSearch.Messages.GetProductElasticResults(searchTerm, pdPageNum, pdPageSize));
                } else {
                    scrollToPd = false;
                }

            });

            $('.js-show-elastic-results', pdCont).click(function (e) {
                e.preventDefault;
                wrapper.submit();
            });
        };

        wrapper.catPaging = function () {
            var catCont = $('.elastic-area.categories', $elastic);
            var catTotal = catCont.data('total');

            if (scrollToCat) {
                $(".result-list-wrapper", $elastic).animate({ scrollTop: catCont.offset().top - $(".result-list-wrapper", $elastic).offset().top }, 1);
            }

            if (catTotal > catPageSize) {
                $('.prev-btn', catCont).removeClass('hidden');
                $('.next-btn', catCont).removeClass('hidden');
            }

            if (catPageStart <= 0) {
                $('.prev-btn', catCont).addClass('disabled');
            }

            if ((catPageStart + catPageSize) >= catTotal) {
                $('.next-btn', catCont).addClass('disabled');
                if (catTotal > catPageSize) {
                    catFirstShown = catPageStart + 1;
                    catLastShown = catTotal;
                    $('.js-cat-info', catCont).append(", <span class='shown'>" + catCont.data('fromtext') + " " + catFirstShown + " " + catCont.data('totext') + " " + catLastShown + "</span>");
                }
            }

            if (((catPageStart + catPageSize) < catTotal) && (catTotal > catPageSize)) {
                catFirstShown = catPageStart + 1;
                catLastShown = catPageStart + catPageSize;
                $('.js-cat-info', catCont).append(", <span class='shown'>" + catCont.data('fromtext') + " " + catFirstShown + " " + catCont.data('totext') + " " + catLastShown + "</span>");
            }

            $('.prev-btn', catCont).click(function () {
                if (!$(this).hasClass('disabled')) {
                    $elastic.addClass('loading');
                    catPageStart -= catPageSize;
                    catPageNum--;
                    scrollToCat = true;
                    scrollToPd = false;
                    scrollToArt = false;
                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.ElasticSearch.Messages.GetCategoryElasticResults(searchTerm, catPageNum, catPageSize));
                } else {
                    scrollToCat = false;
                }
            });

            $('.next-btn', catCont).click(function () {
                if (!$(this).hasClass('disabled')) {
                    $elastic.addClass('loading');
                    catPageStart += catPageSize;
                    catPageNum++;
                    scrollToCat = true;
                    scrollToPd = false;
                    scrollToArt = false;
                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.ElasticSearch.Messages.GetCategoryElasticResults(searchTerm, catPageNum, catPageSize));
                } else {
                    scrollToCat = false;
                }
            });
        };

        wrapper.artPaging = function () {
            var artCont = $('.elastic-area.articles', $elastic);
            var artTotal = artCont.data('total');

            if (scrollToArt) {
                $(".result-list-wrapper", $elastic).animate({ scrollTop: artCont.offset().top - $(".result-list-wrapper", $elastic).offset().top }, 1);
            }

            if (artTotal > artPageSize) {
                $('.prev-btn', artCont).removeClass('hidden');
                $('.next-btn', artCont).removeClass('hidden');
            }

            if (artPageStart <= 0) {
                $('.prev-btn', artCont).addClass('disabled');
            }

            if ((artPageStart + artPageSize) >= artTotal) {
                $('.next-btn', artCont).addClass('disabled');
                if (artTotal > artPageSize) {
                    artFirstShown = artPageStart + 1;
                    artLastShown = artTotal;
                    $('.js-art-info', artCont).append(", <span class='shown'>" + artCont.data('fromtext') + " " + artFirstShown + " " + artCont.data('totext') + " " + artLastShown + "</span>");
                }
            }

            if (((artPageStart + artPageSize) < artTotal) && (artTotal > artPageSize)) {
                artFirstShown = artPageStart + 1;
                artLastShown = artPageStart + artPageSize;
                $('.js-art-info', artCont).append(", <span class='shown'>" + artCont.data('fromtext') + " " + artFirstShown + " " + artCont.data('totext') + " " + artLastShown + "</span>");
            }

            $('.prev-btn', artCont).click(function () {
                if (!$(this).hasClass('disabled')) {
                    $elastic.addClass('loading');
                    artPageStart -= artPageSize;
                    artPageNum--;
                    scrollToArt = true;
                    scrollToPd = false;
                    scrollToCat = false;
                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.ElasticSearch.Messages.GetArticleElasticResults(searchTerm, artPageNum, artPageSize));
                } else {
                    scrollToArt = false;
                }
            });

            $('.next-btn', artCont).click(function () {
                if (!$(this).hasClass('disabled')) {
                    $elastic.addClass('loading');
                    artPageStart += artPageSize;
                    artPageNum++;
                    scrollToArt = true;
                    scrollToPd = false;
                    scrollToCat = false;
                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.ElasticSearch.Messages.GetArticleElasticResults(searchTerm, artPageNum, artPageSize));
                } else {
                    scrollToArt = false;
                }

            });
        };

        wrapper.submit = function () {
            var searchTerm = $input.val();
            var targetUrl = mask.replace("((search))", encodeURIComponent(searchTerm));
            if (showOnlyProducts)
                targetUrl = targetUrl.replace('/search/', '/search-products/');

            document.location = targetUrl;
        };

        wrapper.expand = function () {
            if ($wrapper.hasClass('expanded')) {
                $wrapper.removeClass('expanded');
                $button.trigger('click');
            } else {
                $wrapper.addClass('expanded');
                $input.focus();
                if ($input.val().length >= minLength && wrapper.checkSearchTerm()) {
                    if (ajax) {
                        wrapper.showList(true);
                    }
                }
            }

        };

        wrapper.initSearch = function () {
            if (searchTerm != $input.val()) {
                searchTerm = $input.val();
                pdPageNum = 1;
                pdPageStart = 0;
                scrollToPd = false;
                catPageStart = 0;
                catPageNum = 1;
                scrollToCat = false;
                artPageStart = 0;
                artPageNum = 1;
                scrollToArt = false;
                if (searchTerm.length >= minLength && wrapper.checkSearchTerm()) {
                    if (ajax) {
                        wrapper.loading(true);
                        wrapper.showList(true);
                        model.products = null;
                        model.categories = null;
                        model.articles = null;
                        Vendd.MessageBus.publishAsync(wrapper, new Vendd.ElasticSearch.Messages.GetArticleElasticResults(searchTerm, artPageNum, artPageSize));
                        Vendd.MessageBus.publishAsync(wrapper, new Vendd.ElasticSearch.Messages.GetCategoryElasticResults(searchTerm, catPageNum, catPageSize));
                        Vendd.MessageBus.publishAsync(wrapper, new Vendd.ElasticSearch.Messages.GetProductElasticResults(searchTerm, pdPageNum, pdPageSize));
                    }
                } else {
                    wrapper.showList(false);
                }
            }
        };

        $input.keyup($.debounce(500, function (e) {
            wrapper.initSearch();
        }));

        $input.bind('paste', function (e) {
            if (!e.keyCode) {
                setTimeout(function () {
                    wrapper.initSearch();
                }, 10);
            }
        });

        $input.keyup(function (e) {
            if (e.keyCode === 13 && $input.val().length >= minLength && wrapper.checkSearchTerm()) {
                wrapper.submit();
            }
            if (searchTerm == $input.val()) {
                $elastic.removeClass('loading');
            }
            else {
                $elastic.addClass('loading');
            }
        });

        $input.click(function (e) {
            if (searchTerm.length >= minLength && wrapper.checkSearchTerm()) {
                if (ajax) {
                    wrapper.showList(true);
                }
            } else {
                wrapper.showList(false);
            }
        });

        $toggleButton.click(function (e) {
            wrapper.expand();
        });

        $closeButton.click(function (e) {
            if ($wrapper.hasClass('overlaid')) {
                wrapper.showList(false);
            } else {
                if ($input.val().length >= minLength && wrapper.checkSearchTerm()) {
                    if (ajax) {
                        wrapper.showList(true);
                    }
                }
            }
        });

        $button.click(function (e) {
            e.preventDefault();
            if ($wrapper.hasClass('overlaid')) {
                wrapper.showList(false);
            } else {
                if ($input.val().length >= minLength && wrapper.checkSearchTerm()) {
                    if (ajax) {
                        wrapper.showList(true);
                    }
                }
                $input.focus();
            }
        });

        $('.header-overlay').on('click', function () {
            if ($wrapper.hasClass('overlaid')) {
                $wrapper.removeClass('expanded');
                wrapper.showList(false);
            }
        });

        $(document).keyup(function (e) {
            if (e.keyCode == 27 && $wrapper.hasClass('overlaid')) {
                $wrapper.removeClass('expanded');
                wrapper.showList(false);
            }
        });

        $('.esat-bar').on('click', function () {
            if ($wrapper.hasClass('overlaid')) {
                setTimeout(function () {
                    calculateSearchHeight();
                }, 100);
            }
        });

    });

});
